import { Api } from 'utils';

class ComboService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/combos',params),
		create: async (params?: any) => Api.createResponse('admin/combos/create',params),
		update: async (params?: any) => Api.createResponse('admin/combos/update',params),
		delete: async (params?: any) => Api.createResponse('admin/combos/delete',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/combos/change-status',params),
		getProducts: async (params?: any) => Api.createResponse('admin/combos/products',params),
		view: async (params?: any) => Api.createResponse('admin/combos/view',params),
	}

}

export default ComboService;